import React, { useEffect, useRef, useState } from "react";
import InputField from "../../../components/inputField/InputField";
import { addIcon, searchIcon } from "../../../assets";
import { routeNames } from "../../../constants/constants";
import DashHeader from "../../../components/dashHeader/DashHeader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { createUser, getUsers } from "../../../redux/slices/userSlice";
import { useNavigate } from "react-router-dom";
import Modal from "../../../components/modal/Modal";
import Form from "../../../components/form/Form";
import { USER_FORM } from "../../../constants/user.form.constant";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { userSchema } from "../../../constants/yup.schema";
import { SetTable } from "@/components/SetTable";
import { updateAdminData } from "../../../redux/slices/adminSlice";

const Home: React.FC = () => {
	const [isEdit, setIsEdit] = useState<boolean>(false);
	const [editingUserId, setEditingUserId] = useState<string>("");
	const [searchValue, setSearchValue] = useState<string>("");
	const navigate = useNavigate();
	const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearchValue(e.target.value);
	};
	const dispatch = useDispatch<AppDispatch>();
	const { users } = useSelector((state: RootState) => state.users);
	const filteredUsers = Array.isArray(users)
		? users.filter((guard: any) =>
			guard?.name.toLowerCase().includes(searchValue.toLowerCase())
		)
		: [];
	const tableKeys = [
		{
			name: "name",
		},
		{
			email: "contactInfo.email",
		},
	];
	useEffect(() => {
		dispatch(getUsers());
	}, [dispatch]);

	const handleViewDetails = (user: any) => {
		navigate(`${routeNames.details}/${user._id}`, {
			state: { admin: user },
		});
	};

	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

	const handleModal = () => setIsModalOpen(!isModalOpen);

	const defaultValues = useRef({
		name: "",
		contactInfo: {
			phone: "",
			email: "",
		},
		username: "",
		licenses: 0,
	});

	const methods = useForm({
		defaultValues: defaultValues.current,
		resolver: yupResolver(userSchema),
	});

	const {
		control,
		handleSubmit,
		reset: handleReset,
		formState: { isSubmitting, errors },
	} = methods;

	const onSubmit = async (data: any) => {
		let { name, contactInfo, username, licenses } = data;
		const payload = {
			name,
			contactInfo,
			username,
			licenses,
			role: "PropertyOwner",
		};
		try {
			if (isEdit && editingUserId) {
				await dispatch(updateAdminData({ id: editingUserId, newData: { name, contactInfo, licenses } })).unwrap();
				toast.success("User updated successfully!");
				setIsEdit(false);
			} else {
				await dispatch(createUser(payload));
				toast.success("User created successfully!");
			}
			dispatch(getUsers());
			handleModal();
		} catch (error: any) {
			toast.error(`Failed to create admin: ${error.message || error}`);
		} finally {
			handleReset();
		}
	};

	const handleUpdate = async (item: any) => {
		console.log(item);
		setIsEdit(true);
		setEditingUserId(item._id);
		handleModal();
		handleReset({
			name: item.name,
			contactInfo: {
				phone: item.contactInfo?.phone,
				email: item.contactInfo?.email,
			},
			username: item.adminUsers[1].username,
			licenses: item.licenses,
		});
	};
	const actions = [
		{
			label: "Edit",
			style: "bg-blue-500 text-white hover:bg-blue-700",
			handler: (row: any) => handleUpdate(row),
		},
		// {
		//   label: "Delete",
		//   style: "bg-red-500 text-white hover:bg-red-700",
		//   handler: (row: any) => console.log("Edit clicked for", row),
		// },
		{
			label: "View",
			handler: (row: any) => handleViewDetails(row),
		},
	];
	return (
		<>
			<div className="flex justify-between flex-wrap mt-10">
				<div className="flex flex-col justify-between max-md:py-2 md:py-1">
					<DashHeader title="Developers" icon={addIcon} onClick={handleModal} />
				</div>
			</div>
			<div className="flex px-3  w-full md:w-[327px] my-1.5">
				<InputField name="search" type="text" placeholder="Search Here..." value={searchValue} onChange={handleSearchChange} icon={searchIcon} />
			</div>
			<SetTable data={filteredUsers} tableKeys={tableKeys} actions={actions} />
			<Modal isModalOpen={isModalOpen} onClick={handleModal} title="Add new developer/property owner">
				<Form fields={USER_FORM} control={control} method={methods} onClick={handleSubmit((data) => onSubmit(data))} errors={errors} isSubmitting={isSubmitting} style="grid grid-cols-2 gap-4" />
			</Modal>
		</>
	);
};

export default Home;
